// Module
var code = "<div class=\"block height-100\" id=\":elementId\"> <h2>Financial Statement</h2> <div id=\"optionSelector\"></div> <div id=\"statementLoadingMessage\"></div> <div> <div class=\"button is-small\" d-action=\"exportTable\">Export</div> </div> <div id=\"grid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;